<script>
export default {
  props: {
    news: {
      type: Object,
    },
  },
};
</script>

<template>
  <div>
    <router-link :to="{name: 'OrganizationView', params: {id: news.textParams[0]}}">
      {{ news.textParams[1] }}
    </router-link>
    {{$t('news.template.opinion.changedAndMadePublicByOrg.p1')}}
    "
    <router-link
      :to="{name: 'OpinionView', params: {hash: news.textParams[2]}}"
    >{{ news.textParams[3] }}
    </router-link>
    "
    {{$t('news.template.opinion.changedAndMadePublicByOrg.p2')}}
    {{ news.textParams[4] }}
    {{$t('news.template.opinion.changedAndMadePublicByOrg.p3')}}
    "
    <router-link :to="{name: 'OpinionView', params: {hash: news.textParams[2]}}">
      {{ news.textParams[5] }}
    </router-link>
    "
    {{$t('news.template.opinion.changedAndMadePublicByOrg.p4')}}
  </div>
</template>
